import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EntityTypes } from '@models/enums/EntityTypes';
import {
    EditorComponentBase,
    GenericDropdownMultiselectComponent,
    GenericTypeAheadMultiselectComponent
} from 'ngx-lib';
import { ValidationErrorMessageComponent } from '../../validation-error-message/validation-error-message.component';
import { EntityComponentType } from './entity-enums/entity';
import { EntityFactory } from './entity-factory/entity-factory';
import { IComponentEditorEntity } from './entity-interfaces/editor-entity.interface';
import { IEntity } from './entity-interfaces/entity.interface';

@Component({
    selector: 'app-entity-editor',
    templateUrl: './entity-editor.component.html',
    styleUrls: ['./entity-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        GenericTypeAheadMultiselectComponent,
        GenericDropdownMultiselectComponent,
        ValidationErrorMessageComponent
    ]
})
export class EntityEditorComponent extends EditorComponentBase<unknown> implements OnInit {
    entity!: IComponentEditorEntity<IEntity, unknown>;
    source: IEntity[];
    selectedItems: IEntity[];
    entityType?: EntityTypes;
    entityComponentType?: EntityComponentType;

    constructor(private readonly injector: Injector) {
        super();
        this.source = [];
        this.selectedItems = [];
    }

    async ngOnInit(): Promise<void> {
        if (!this.entityId) return;

        this.entity = EntityFactory.create(this.entityId, this.injector);

        this.entityType = this.additionalInfo?.entityType;

        this.entityComponentType = this.additionalInfo?.entityComponentType ?? EntityComponentType.dropdownMultiselect;

        this.source = await this.entity.getSource(this.entityType);

        if (Array.isArray(this.bindingProperty) && this.bindingProperty?.length) {
            this.selectedItems = this.bindingProperty.map((item) => this.entity?.toSource(item));
        }
    }

    onSelectedItemChange() {
        this.bindingProperty = this.selectedItems.length
            ? this.selectedItems.map((item) => this.entity?.toDestination(item))
            : [];
        this.validate();
        this.valueChange.emit();
    }

    async onEntityTextChange(event: string): Promise<void> {
        this.source = await this.entity.getSource(this.entityType, event);
    }
}
